import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { WarningCircle } from '@phosphor-icons/react';

const ProvincesClosedPage = () => {
  const { axiosInstance } = useAuth();
  const [provinces, setProvinces] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProvinces();
  }, []);

  const fetchProvinces = async () => {
    try {
      const { data } = await axiosInstance.get('/provinces/closed');
      setProvinces(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-[#0A2540] border-r-transparent"></div>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto space-y-6" data-testid="provinces-closed-page">
      <div>
        <h1 className="text-4xl font-extrabold tracking-tighter text-slate-900">Province Chiuse</h1>
        <p className="mt-2 text-sm text-slate-600">Province precedentemente attive ma senza POD in fornitura</p>
      </div>

      {provinces.length === 0 ? (
        <div className="bg-slate-50 border border-slate-200 rounded-sm p-8 text-center">
          <WarningCircle size={32} className="mx-auto text-slate-400 mb-3" />
          <p className="text-sm text-slate-600">Nessuna provincia chiusa al momento.</p>
        </div>
      ) : (
        <div className="bg-white border border-slate-200 rounded-sm overflow-hidden">
          <table className="w-full" data-testid="closed-provinces-table">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-200">
                <th className="text-left px-6 py-3 text-xs font-semibold text-slate-600 uppercase tracking-wider">Provincia</th>
                <th className="text-right px-6 py-3 text-xs font-semibold text-slate-600 uppercase tracking-wider">POD Storici</th>
                <th className="text-center px-6 py-3 text-xs font-semibold text-slate-600 uppercase tracking-wider">Stato Comunicazione</th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-slate-600 uppercase tracking-wider">Motivo Chiusura</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {provinces.map((prov) => (
                <tr key={prov.province} className="hover:bg-slate-50 transition-colors">
                  <td className="px-6 py-4 text-sm font-bold text-slate-900">{prov.province}</td>
                  <td className="px-6 py-4 text-sm text-slate-700 text-right">{prov.historical_pods}</td>
                  <td className="px-6 py-4 text-center">
                    <span className="text-xs font-medium text-slate-600 bg-slate-100 px-2 py-1 rounded-sm">
                      {prov.communication_status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-xs text-slate-500">{prov.closed_reason}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ProvincesClosedPage;
